import React from 'react';
import { Plus, TrashBin } from '@gravity-ui/icons';
import { Button, Icon, Table } from '@gravity-ui/uikit';
import noop from 'lodash/noop';
import set from 'lodash/set';
import { Controller, OBJECT_ARRAY_CNT, OBJECT_ARRAY_FLAG, isArraySpec, isBooleanSpec, isObjectSpec, transformArrIn, } from '../../../../core';
import { useSearchContext } from '../../../../core/components/Form/hooks';
import { block } from '../../../utils';
import './TableArrayInput.css';
const b = block('table-array');
export const TableArrayInput = ({ spec, name, arrayInput, input }) => {
    const { isHiddenField } = useSearchContext();
    const keys = React.useMemo(() => Object.keys(arrayInput.value || {})
        .filter((k) => k !== OBJECT_ARRAY_FLAG && k !== OBJECT_ARRAY_CNT)
        .map((k) => k.split('<').join('').split('>').join(''))
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => ({
        key,
    })), [arrayInput.value]);
    const onItemAdd = React.useCallback(() => {
        arrayInput.onItemAdd({});
    }, [arrayInput.onItemAdd]);
    const onItemRemove = React.useCallback((key) => {
        arrayInput.onItemRemove(key);
    }, [arrayInput.onItemRemove]);
    const parentOnChange = React.useCallback((childName, childValue, childErrors) => input.onChange((currentValue) => set(Object.assign({}, currentValue), childName.split(`${input.name}.`).join(''), childValue), childErrors), [input.onChange, input.name]);
    const columns = React.useMemo(() => {
        const { items, viewSpec: { table }, } = spec;
        if (!(table === null || table === void 0 ? void 0 : table.length) || !isObjectSpec(items)) {
            return null;
        }
        const idxColumn = {
            id: 'idx',
            name: '',
            sticky: 'left',
            template: ({ key }, idx) => (React.createElement("div", { className: b('idx'), key: `idx-${key}` }, idx + 1)),
        };
        const removeColumn = {
            id: 'remove',
            name: '',
            sticky: 'right',
            template: ({ key }) => (React.createElement(Button, { view: "flat-secondary", onClick: () => onItemRemove(key), key: `remove-${key}`, qa: `${name}-item-remove-${key}` },
                React.createElement(Icon, { data: TrashBin, size: 16 }))),
        };
        const columns = table.map(({ property, label }) => ({
            id: property,
            name: label,
            template: ({ key, }, idx) => {
                var _a, _b, _c;
                const entitySpec = (_a = items === null || items === void 0 ? void 0 : items.properties) === null || _a === void 0 ? void 0 : _a[property];
                if (!entitySpec) {
                    return null;
                }
                const preparedEntitySpec = Object.assign(Object.assign({}, entitySpec), { viewSpec: Object.assign(Object.assign({}, entitySpec.viewSpec), { layoutTitle: table.map(({ label }) => label).join(` ${idx + 1} `) + ` ${idx + 1}` }) });
                return (React.createElement("div", { className: b('cell', {
                        bool: isBooleanSpec(preparedEntitySpec),
                        arr: isArraySpec(preparedEntitySpec),
                        obj: isObjectSpec(preparedEntitySpec),
                    }), key: `${name}.<${key}>.${property}` },
                    React.createElement(Controller, { value: (_c = (_b = input.value) === null || _b === void 0 ? void 0 : _b[`<${key}>`]) === null || _c === void 0 ? void 0 : _c[property], spec: preparedEntitySpec, name: `${name}.<${key}>.${property}`, parentOnChange: parentOnChange, parentOnUnmount: noop })));
            },
        }));
        return [idxColumn, ...columns, removeColumn];
    }, [name, spec, onItemRemove, parentOnChange, input.parentOnUnmount, input.value]);
    const getRowClassNames = React.useCallback(({ key }) => {
        var _a;
        const searchResult = (_a = spec.viewSpec.table) === null || _a === void 0 ? void 0 : _a.every(({ property }) => isHiddenField(`${name}.<${key}>.${property}`));
        return [b('row', { hidden: searchResult })];
    }, [isHiddenField, name, spec.viewSpec.table]);
    if (!columns) {
        return null;
    }
    return (React.createElement("div", { className: b() },
        keys.length ? (React.createElement(Table, { className: b('table'), data: keys, columns: columns, getRowId: (_, idx) => `${name}-${idx}`, verticalAlign: "top", getRowClassNames: getRowClassNames })) : null,
        !arrayInput.value && spec.defaultValue ? (React.createElement(Button, { onClick: () => input.onChange(transformArrIn(spec.defaultValue)), disabled: spec.viewSpec.disabled, qa: `${name}-init-arr` },
            React.createElement(Icon, { data: Plus, size: 14 }),
            spec.viewSpec.layoutTitle || null)) : (React.createElement(Button, { onClick: onItemAdd, disabled: spec.viewSpec.disabled, qa: `${name}-add-item` },
            React.createElement(Icon, { data: Plus, size: 14 }),
            spec.viewSpec.itemLabel || null))));
};
